import axiosClient from "../axios-client";

/* Thin builders for endpoints on the shared server-side list contract.
   `params` comes straight from useListState. */

export const makeListGetter = (path) => async (params) => {
    const qs = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") qs.set(k, v);
    });
    return axiosClient.get(`${path}?${qs}`).then((res) => res?.data);
};

/** View-tab counts are decorative; a failure must not blank the screen. */
export const makeCountsGetter = (path) => async () =>
    axiosClient.get(path).then((res) => res?.data || {}).catch(() => ({}));

export const listReports = makeListGetter("/report/v3/list");
export const getReportCounts = makeCountsGetter("/report/v3/list/counts");

export const listOrderedReports = makeListGetter("/report/v3/ordered-reports");

export const listNameCorrections = makeListGetter("/name-correction/v3/list");
export const getNameCorrectionCounts = makeCountsGetter("/name-correction/v3/list/counts");
